var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('f7-navbar',{attrs:{"title":"員工管理"}},[_c('f7-nav-left',[_c('f7-link',{attrs:{"icon-if-ios":"f7:menu","icon-if-md":"material:menu","panel-open":"left"}})],1)],1),_vm._v(" Some information ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }